import { render } from "./AppBreadcrumbItem.vue?vue&type=template&id=1bfac0e1&ts=true"
import script from "./AppBreadcrumbItem.vue?vue&type=script&lang=ts"
export * from "./AppBreadcrumbItem.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__